<section class="content head">
  <iaud-audit-nav-bar class="audit-list__nav-bar" *ngIf="!auditId"></iaud-audit-nav-bar>
  <div class="content-wrapper finding-list">
    <h1 class="finding-list__header" *ngIf="auditId">Findings List</h1>
    <h1 class="finding-list__header" *ngIf="!auditId">All Findings List</h1>
    <div class="finding-list__buttons">
      <button mat-raised-button class="right-margin" [color]="'accent'" routerLink="finding/add" *ngIf="auditStatus === auditStatusEnum.DRAFT">+ Add Finding</button>
    </div>

    <mat-card class="finding-list__panel" *ngIf="!hasInitialFindings">
      <div class="finding-list__no-findings">
        <div class="finding-list__no-findings--icon">
          +
        </div>
        <div class="finding-list__no-findings--text">
          <h1>No Findings</h1>
          <p>There are no findings</p>
          <p>Please add new Finding</p>
        </div>
        <button mat-raised-button class="finding-list__no-findings--add-button" [color]="'accent'" routerLink="finding/add">
          + Add Finding
        </button>
      </div>
    </mat-card>
  </div>
</section>

<section class="content" *ngIf="hasInitialFindings">
  <div class="content-wrapper">
    <iaud-table 
        [data]="findingTableData" 
        [options]="findingTableOptions" 
        [forceReloadEvent]="forceReloadEvent"
        [dataRefreshCallback]="reloadFindingList.bind(this)" 
        [dataDeleteCallback]="deleteData.bind(this)" 
        [deleteTitle]="'Delete Finding'"
        [deleteText]="'Are you sure you want to delete ${data.findingTitle} finding?'">

    </iaud-table>
  </div>
</section>

<ng-template #capaCellTemplate let-rowData="rowData">
  <div class="capa-cell">
    <span class="text">
      {{rowData.capaCount}}
    </span>
    <div class="button" [routerLink]="'/audit/'+this.auditId+'/finding/' + rowData.id + '/capa/add'" *ngIf="auditStatus === auditStatusEnum.DRAFT">+</div>
  </div>
</ng-template>
<ng-template #statusCellTemplate let-rowData="rowData">
  <iaud-audit-capa-status [status]="rowData.capaActivityStatus"></iaud-audit-capa-status>
</ng-template>
<ng-template #ownersDetailTemplate let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngFor="let sme of detailData.item[detailOption.fieldName]">
    {{ sme.fullName }}
  </p>
</ng-template>